export default "__VITE_ASSET__Bxs_KG3E__"